<template>
  <v-container id="dashboard" fluid tag="section">
    <template v-for="(rest) in restaurantesIterar">
      <v-row :key="rest.id + '_head'" justify="center">
        <h3 class="headline">{{rest.nombre}}</h3>
      </v-row>
      <v-row :key="rest.id">
        <v-col cols="12" lg="4">
          <base-material-stats-card
            color="info"
            icon="mdi-shopping"
            title="Pedidos"
            :value="numeroPedidosRestaurante(rest.id)"
            sub-icon="mdi-clock"
            sub-text="En el día de hoy"
          />
        </v-col>

        <v-col cols="12" lg="4">
          <base-material-stats-card
            color="primary"
            icon="mdi-currency-eur"
            title="Ganancias"
            :value="gananciasRestaurante(rest.id)"
            sub-icon="mdi-clock"
            sub-text="En el día de hoy"
          />
        </v-col>

        <v-col cols="12" lg="4">
          <base-material-card icon="mdi-store" class="v-card--material-stats">
            <template v-slot:after-heading>
              <div class="ml-auto text-right">
                <div class="body-3 grey--text font-weight-light">Estado</div>
                <h3 class="body-3 font-weight-light text--primary">
                  <div>
                    Domicilio:
                    <v-chip
                      v-if="rest.domicilio"
                      class="ma-2"
                      color="green"
                      text-color="white"
                    >Abierto</v-chip>
                    <v-chip v-else class="ma-2" color="red" text-color="white">Cerrado</v-chip>
                  </div>
                  <div>
                    Recogida:
                    <v-chip
                      v-if="rest.recogida"
                      class="ma-2"
                      color="green"
                      text-color="white"
                    >Abierto</v-chip>
                    <v-chip v-else class="ma-2" color="red" text-color="white">Cerrado</v-chip>
                  </div>
                  <div>
                    Apertura:
                    <v-chip
                      v-if="rest.apertura"
                      class="ma-2"
                      color="green"
                      text-color="white"
                    >Abierto</v-chip>
                    <v-chip v-else class="ma-2" color="red" text-color="white">Cerrado</v-chip>
                  </div>
                  <div>
                    Conectado:
                    <v-chip v-if="rest.estado" class="ma-2" color="green" text-color="white">On</v-chip>
                    <v-chip v-else class="ma-2" color="red" text-color="white">Off</v-chip>
                  </div>
                </h3>
              </div>
            </template>
            <v-col cols="12" class="px-0">
              <v-divider />
            </v-col>
            <v-icon size="16" class="ml-2 mr-1">mdi-alert</v-icon>
          </base-material-card>
        </v-col>
      </v-row>
    </template>
  </v-container>
</template>

<script>
import { mostrarMoneda } from "@/utils/utils.js";
import { mapGetters, mapState } from "vuex";
export default {
  name: "DashboardDashboard",

  data() {
    return {};
  },

  computed: {
    ...mapGetters({
      negocioGestSlug: "app/negocioGestObj",
      numPedidos: "pedidos/numeroPedidosRestaurante",
      //ganancias: "pedidos/gananciasRestaurante",
    }),
    ...mapState({
      restaurantes: (state) => state.app.restaurantesArray,
    }),
    restaurantesIterar() {
      var devolver = [];
      this.restaurantes.forEach((r) => {
        const aux = {
          id: r.id,
          nombre: r.nombre,
          domicilio: r.horariosComputados ? r.horariosComputados[0] : false,
          recogida: r.horariosComputados ? r.horariosComputados[1] : false,
          apertura: r.horariosComputados ? r.horariosComputados[2] : false,
          estado: r.estado ? r.estado : false,
          pedidos: this.numPedidos,
          ganancias: this.ganancias,
        };
        devolver.push(aux);
      });
      return devolver;
    },
  },

  methods: {
    gananciasRestaurante(id) {
      var foundPedidos = this.$store.state.pedidos.pedidosArray.find(
        (r) => r.id == id
      );
      if (foundPedidos) {
        const res = foundPedidos.array
          .filter((p) => !p.eliminado)
          .reduce(function (a, { precioTotal }) {
            return a + precioTotal;
          }, 0);
        return mostrarMoneda(res, true) + " €";
      } else {
        return 0;
      }
    },
    numeroPedidosRestaurante(id) {
      var foundPedidos = this.$store.state.pedidos.pedidosArray.find(
        (r) => r.id == id
      );
      if (foundPedidos) {
        return foundPedidos.array.filter((p) => !p.eliminado).length.toString();
      } else {
        return 0;
      }
    },
    complete(index) {
      this.list[index] = !this.list[index];
    },
    goAlerta() {
      this.router.push("/admin/alertas");
    },
  },
};
</script>
